import React, { useContext, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import InputGroup from "react-bootstrap/InputGroup";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import UserContext from "contexts/UserContext";
import NavContext from "contexts/NavContext";
import LoginLink from "./LoginLink";
import SkeletonLoader from "components/SkeletonLoader";
import { sizeEqualOrLessThan } from "utils/helpers";

export default function UserDropdown(props) {
	const { logout, isLoading } = useAuth0();

	const { user, setUser, fetchingUser, shopAccountUrl } = useContext(UserContext);
	const { userDropdownOpen, setUserDropdownOpen, scrollHeaderLimit } = useContext(NavContext);
	const isMobile = sizeEqualOrLessThan("md");

	// console.log({ fetchingUser, isLoading, user });

	useEffect(() => {
		if (scrollHeaderLimit && !isMobile && userDropdownOpen) {
			setUserDropdownOpen(false);
		}
	}, [scrollHeaderLimit, userDropdownOpen, isMobile]);

	if (fetchingUser) {
		return <SkeletonLoader width="75px" />;
	}
	if (!user) {
		return <LoginLink className="pe-1 pe-sm-3" />;
	}

	return (
		<InputGroup size="sm" className="user-dropdown justify-content-end d-flex w-auto">
			<DropdownButton
				show={userDropdownOpen}
				onToggle={(show) => {
					setUserDropdownOpen(show); //this changes z-index on nav and sub nav
				}}
				variant=""
				title={user?.name}
				id="user-dropdown"
			>
				<Dropdown.Item href={`${shopAccountUrl}`}>
					My Orders
					{/* /> */}
					{/* </div> */}
				</Dropdown.Item>
				<Dropdown.Item href={`${process.env.APP_URL}`}>My Dashboard</Dropdown.Item>
				<Dropdown.Item onClick={() => logout({ logoutParams: { returnTo: process.env.AUTH0_REDIRECT_URI } })}>
					<span className="myDashboard pe-3">Logout</span>
				</Dropdown.Item>
			</DropdownButton>
			<style global jsx>{`
				.user-dropdown .dropdown-toggle.btn {
					min-width: 160px;
					display: flex;
					justify-content: end;
					align-items: center;
				}
			`}</style>
		</InputGroup>
	);
}
